import { IRowData } from "@multiweb/types/contracts";
import { EditableDataRow } from "../../../../UI.Controls/DataGridSubcontrols/Components/EditableDataRow";
import { IDataRowElement, IListDataRowElement } from "../../../../UI.Controls/DataGridSubcontrols/Components/IDataRow";
import { IMSLOVRowData } from "../../../../UI.Controls/DataSource/MSLOVDBDataSource";
import { ListDataGrid } from "../../../../UI.Controls/ListDataGrid";
import { registerCustomElement } from "../../../../UI.ElementarControls/Utils/CustomElementUtils";

export class MSLOVGrid<R extends IListDataRowElement> extends ListDataGrid<R> {
    protected override _constructor(): void {
        super._constructor();
    }

    public override async initialize(): Promise<any> {
        await super.initialize();

        this.dataSource.attributesChanged.add((_sender, eventData) => {
            const el = this._dataTable.querySelector(`:scope > [datakey='${eventData.key}']`) as EditableDataRow;

            if (!el)
                return;

            for (const data of eventData.values) {
                el.setData(data["0"], data["1"]);
            }
        });
    }

    protected override _createRows(data: Iterable<IMSLOVRowData>): void {
        let i = 0;
        for (const row of data) {
            if (row.preselect)
                this._createPreselectRow((row.data as IRowData));
            else {
                if (this.isSelectedAll) {
                    // pokud byly nacteny dalši data a neni nastaven jako vybrany nastavi zrusi se nastaveni isSelectedAll
                    this.isSelectedAll = false;
                }
                this._createRow((row.data as IRowData));
            }
            if (++i >= this.fetchCount)
                break;
        }
    }

    /**
     * Vytvoreni jednoho radku
     * @param data Data záznamu
     */
    protected override _createRow(data: IRowData): R {
        const dataRow = this._dataRowFactory(this, data);

        dataRow.init(data, this, this._createRowControlElement(dataRow));
        this.initDataRowFlag(dataRow, data);

        this.dataRows.push(dataRow);
        //if (this.isSelectedAll) dataRow.isSelected = true;
        //else dataRow.isSelected = false;

        return dataRow;
    }

    protected _createPreselectRow(data: IRowData): IDataRowElement {
        const exist = this.dataRows.filter((item) => item.dataKey === data.ID.valueOf());
        if (exist.length > 0) {
            exist[0].isSelected = true;
            return exist[0];
        }

        const dataRow = this._dataRowFactory(this, data);

        dataRow.init(data, this, this._createRowControlElement(dataRow));
        this.initDataRowFlag(dataRow, data);

        this.dataRows.push(dataRow);
        dataRow.isSelected = true;

        return dataRow;
    }
}

registerCustomElement("tsc-MSLovDataGrid", MSLOVGrid);
